import { createContext } from 'react';
import type { History } from '../buildHistory';

export const HistoryContext = createContext<History | undefined>(undefined);
